// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__DR5ex","text":"ErrorPage_text__s7JUW","reason":"ErrorPage_reason__ybRGd","btn_back":"ErrorPage_btn_back__1L076"};